export const transitionEventCopy: Record<string, string> = {
  activeSelfPay: 'Self-Pay',
  activeSponsored: 'Continue Sponsored Care',
  cancel: 'Cancel',
  onHold: 'On-Hold',
};
